/** PieChart — tier-2 adapter. `variant="donut"` adds the inner radius. */
import { useMemo } from 'react';
import { Chart, type ChartBaseProps } from './Chart';
import type { ChartConfig } from './types';

export interface PieChartProps extends ChartBaseProps {
  /** Field name holding the slice label. */
  nameKey: string;
  /** Field name holding the slice value. */
  valueKey: string;
  variant?: 'pie' | 'donut';
  title?: string;
}

export function PieChart({ nameKey, valueKey, variant = 'pie', title, ...rest }: PieChartProps) {
  const config: ChartConfig = useMemo(
    () => ({
      title,
      chartType: variant,
      series: [{ id: valueKey, name: title ?? valueKey, fields: { x: nameKey, y: valueKey } }],
    }),
    [nameKey, valueKey, variant, title],
  );
  return <Chart config={config} {...rest} />;
}
